/**
 * Upsell Quantity Sync
 * Intercepts /cart/add requests to set upsell product quantities
 * to match the main product quantity.
 */
(function () {
  var origFetch = window.fetch;
  window.fetch = function (url, options) {
    if (
      typeof url === 'string' &&
      url.indexOf('cart/add') !== -1 &&
      options &&
      options.body instanceof FormData
    ) {
      var fd = options.body;

      // Collect upsell variant IDs from product-info-upsell elements on the page
      var upsellIds = new Set();
      document.querySelectorAll('product-info-upsell').forEach(function (el) {
        upsellIds.add(String(el.dataset.id));
      });

      if (upsellIds.size > 0) {
        // Parse items from FormData
        var items = {};
        for (var pair of fd.entries()) {
          var key = pair[0], value = pair[1];
          var m = key.match(/^items\[(\d+)]\[(\w+)]$/);
          if (m) {
            if (!items[m[1]]) items[m[1]] = {};
            items[m[1]][m[2]] = value;
          }
        }

        // Find main product quantity (first item NOT matching an upsell ID)
        var mainQty = 1;
        for (var idx in items) {
          if (!upsellIds.has(String(items[idx].id))) {
            mainQty = parseInt(items[idx].quantity) || 1;
            break;
          }
        }

        // Set upsell item quantities to match main product
        for (var idx in items) {
          if (upsellIds.has(String(items[idx].id))) {
            fd.set('items[' + idx + '][quantity]', String(mainQty));
          }
        }
      }
    }

    return origFetch.apply(this, arguments);
  };
})();
